module.exports = __webpack_public_path__ + "img/file-doc-business.b976885a.svg";